Namespace 'Common.Dashboard'

class Common.Dashboard.Widget extends Backbone.Model
  sortData: (data) =>
    SORT_TYPE = @constructor.SortType
    switch @get('sorting')
      when SORT_TYPE.descCount then _.sortBy(data, 'value').reverse()
      when SORT_TYPE.ascCount then _.sortBy(data, 'value')
      when SORT_TYPE.descAlphabetical then _.sortBy(data, (d) -> d.name.toLowerCase()).reverse()
      when SORT_TYPE.ascAlphabetical then _.sortBy(data, (d) -> d.name.toLowerCase())
      else
        data

  shouldAddMissing: (data) =>
    @get('show_missing') && data.missing?

  canSort: =>
    @isBarOrColumn()

  canSelectQuantityToShow: =>
    @isBarOrColumn()

  isBarOrColumn: ->
    @get('chart_type') == @constructor.ChartType.bar || @get('chart_type') == @constructor.ChartType.column

  canShowMissingOption: (data) =>
    data.missing? || @get('dimension') == Common.WidgetDimensions.HIERARCHICAL_ATTRIBUTE

  canToggleWorkCalendar: =>
    @get('use_work_calendar') != undefined

  @ChartType =
    pie: 'pie'
    bar: 'bar'
    column: 'column'

  @SortType =
    ascCount: 'ascCount'
    descCount: 'descCount'
    ascAlphabetical: 'ascAlphabetical'
    descAlphabetical: 'descAlphabetical'

  updateWidget: (successCallback = null) =>
    @save({}, {
        error: -> showError(I18n.t('generic_error_message')),
        success: -> successCallback?()
      }
    )

  updateHierarchicalLevel: (code, successCallback) =>
    hierarchical_tags_options = {code: code}
    data = $.extend({}, @attributes, {hierarchical_tags_options: hierarchical_tags_options})
    $.ajax
      url: "#{@url()}/update_and_execute"
      method: 'POST'
      data: JSON.stringify(data)
      contentType: 'application/json'
      success: (response) =>
        data = response.widgets[@get('id')]
        @set('hierarchical_tags_options', hierarchical_tags_options)
        successCallback(data)
      error: -> showError(I18n.t('generic_error_message'))

class Common.Dashboard.WidgetCollection extends Backbone.Collection
  model: Common.Dashboard.Widget

  initialize: (models) ->
    super(models)

  addWidget: (widget_data) ->
    $.ajax
      url: @url
      method: 'POST'
      data: JSON.stringify(widget_data: widget_data)
      contentType: 'application/json'
      success: (response) =>
        @add(new @model(response.widget))
        @trigger('session:execution', response.execution_result)
        @trigger('session:widgets:add:finished', response.execution_result)
      error: (e) ->
        showError(I18n.t('generic_error_message'))

  updateWidgets: ->
    $.ajax
      url: @url
      method: 'PUT'
      data: JSON.stringify widgets: @
      contentType: 'application/json'
      error: -> showError(I18n.t('generic_error_message'))

  swapWidgets: (firstIndex, secondIndex) ->
    [@models[firstIndex], @models[secondIndex]] = [@models[secondIndex], @models[firstIndex]]
    @updateWidgets()

  setSessionUrl: (sessionUrl) ->
    @url = sessionUrl + '/widgets'

  getWidgetIds: ->
    @models.map((widget) -> widget.id)
